'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbChatInputDirective($window) {
    return {
        restrict: 'A',
        scope: {},
        link: cbStripChatInputV1Link
    };

    function cbStripChatInputV1Link(scope, element) {

        function init() {
            element.on('keypress', mobileKeyboardEnter);
        }

        init();

        var mobileKeyboardEnter = function mobileKeyboardEnter(event) {
            if (event.key === 'Enter') {
                var chatContainer = angular.element('#iChatConversation');
                // focus on chat top
                if ($window.gWebClient) {
                    $window.gWebClient.SubmitUserMessage(null);
                    $window.scrollTo(0, chatContainer[0].getBoundingClientRect().top + $window.scrollY);
                    scope.$apply();
                }
            }
        };

        scope.$on('$destroy', function () {
            element.off('keypress');
        });
    }
}

cbChatInputDirective.$inject = ['$window'];

exports.default = cbChatInputDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/cb-chat-input.directive.js
// module id = 865
// module chunks = 0